import {Errors} from "../../apps/types";

export type SignInResponse = SignInSuccessResponse | SignInNextStepResponse | SignInFailedResponse;

export type SignInNextStepResponse = {
  status: SignInStatus.NEXT_STEP | SignInStatus.SUCCESS;
  captcha: boolean;
  otp: OTPResponse;
  step: SignInStep;
  type: SignInType.UNDEFINED;
}

export type SignInFailedResponse = {
  status: SignInStatus.FAILED;
  captcha: boolean;
  errors: Errors;
  step: SignInStep;
  type: SignInType.UNDEFINED;
}

export type SignInSuccessResponse = {
  status: SignInStatus.SUCCESS;
  captcha: boolean;
  type: SignInType.LOG_IN;
}

export enum SignInStatus {
  SUCCESS = "success",
  FAILED = "failed",
  NEXT_STEP = "next_step",
}

type OTPResponse = {
  cooldownSeconds: number;
  isSent: boolean;
  target: string;
}

export enum SignInStrategy {
  OTP = "otp",
  YANDEX = "yandex",
}

export enum SignInType {
  SIGN_UP = "sign_up",
  LOG_IN = "log_in",
  UNDEFINED = "undefined",
}

export enum SignInStep {
  EMAIL_OR_PHONE_ENTERING = "email_or_phone_entering",
  EMAIL_OTP = "email_otp",
  EMAIL_OTP_FOR_LOGIN_BY_PHONE = "email_otp_for_login_by_phone",
  PHONE_OTP = "phone_otp",
  PHONE_OTP_FOR_LOGIN_BY_EMAIL = "phone_otp_for_login_by_email",
  PHONE_OTP_UNAVAILABLE = "phone_otp_unavailable",
  CAPTCHA = "captcha",
  TOKEN_HANDLING = "token_handling",
}